var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBagIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.224,
    height: 20,
    viewBox: "0 0 22.224 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#0089ce;stroke-linecap:round;stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-767.793 -242)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20.81,
    height: 15.381,
    rx: 2,
    transform: "translate(768.5 246.119)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M789.309,249.5l-1.484,1.526a7.242,7.242,0,0,1-3.03,1.863l-3.629,1.135v-.9a.905.905,0,0,0-.9-.9h-2.714a.905.905,0,0,0-.9.9v.9L773,252.88a7.237,7.237,0,0,1-3.033-1.87L768.5,249.5",
    transform: "translate(0 -0.667)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1,0H7.143a1,1,0,0,1,1,1V3.619a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V1A1,1,0,0,1,1,0Z",
    transform: "translate(774.833 242.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 4.524,
    height: 3.619,
    rx: 1,
    transform: "translate(776.643 251.548)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagIcon);
export default __webpack_public_path__ + "static/media/bag-icon.3ea7f28cf80a463e55546e64e7781ea4.svg";
export { ForwardRef as ReactComponent };